module.exports = __webpack_public_path__ + "img/122.89eef979.jpg";